import { FC, PropsWithChildren } from 'react';
import { Typography } from '@dagensmat/carrot/Components';

export const FormFieldLabel: FC<PropsWithChildren> = ({ children }) => {
  return <Typography variant="inputLabel">{children}</Typography>;
};
